import { axios } from "../lib/axios";

export const getServiceProviders = async function (serviceId) {
  try {
    const response = await axios.get("booking/getserviceproviders", {
      params: { serviceId: serviceId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getServiceProviderById = async function (serviceProviderId) {
  try {
    const response = await axios.get("booking/getserviceproviderbyid", {
      params: { serviceProviderId: serviceProviderId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const getServiceProviderSchedulesById = async function (
  serviceProviderId
) {
  try {
    const response = await axios.get("booking/getserviceproviderschedulebyid", {
      params: { serviceProviderId: serviceProviderId },
    });
    return response.data.data;
  } catch (error) {
    return error.response;
  }
};

export const addServiceProvider = async function (model) {
  try {
    const response = await axios.post("booking/addserviceprovider", model, {
      header: { "Content-Type": "multipart/form-data" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};

export const updateServiceProvider = async function (model) {
  try {
    const response = await axios.post("booking/updateserviceprovider", model, {
      header: { "Content-Type": "multipart/form-data" },
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
